import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";
import DTOLargeData = namaTypes.DTOLargeData;

export default class FileUploaderValueFormatter extends AbsEditViewValueFormatter {
  private static _instance: FileUploaderValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new FileUploaderValueFormatter();
    return this._instance;
  }

  override format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any): any {
    if (value && value.attachmentInfo && !value.attachmentInfo.removed)
      return value
    return {} as DTOLargeData;
  }

  override parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any): any {
    return value ?? {} as DTOLargeData;
  }
}
